import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-testid": "audit-quality-warnings",
  class: "flex flex-col gap-2 rounded-lg border border-alert bg-alert/10 p-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "w-fit rounded bg-alert px-2 py-[2px] text-[11px] font-bold uppercase leading-4 tracking-wide text-white" }, " Qualidade da foto ", -1)
const _hoisted_3 = {
  class: "text-sm leading-[18px] text-textPrimary",
  "data-testid": "audit-quality-warnings-title"
}
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "list-disc pl-5 m-0 text-sm text-textPrimary" }

import { computed } from 'vue'
import {
  qualityWarningsTitle,
  translateQualityWarnings
} from '@/components/designSystem/modals/AttendanceUploadModal/quality-warnings'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceQualityWarnings',
  props: {
    warnings: {}
  },
  setup(__props: any) {

const props = __props;



const messages = computed(() => translateQualityWarnings(props.warnings ?? []))

return (_ctx: any,_cache: any) => {
  return (messages.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(qualityWarningsTitle)(messages.value.length)) + ":", 1),
          _createTextVNode(" a folha foi enviada mesmo com os avisos abaixo. Confira essas páginas com atenção. ")
        ]),
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              "data-testid": "audit-quality-warning"
            }, _toDisplayString(message), 1))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})